module.exports = __webpack_public_path__ + "static/media/placeholder.47495035.svg";